import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import './node-style.css'

const propTypes = {
    nodeData: PropTypes.object.isRequired
}

const cardStyle = {
    maxWidth: '300px', 
    width: 'auto', 
    minWidth: '250px', 
    paddingTop: 5, 
    paddingBottom: 5, 
    paddingLeft: 12, 
    paddingRight: 12,
    border: '1px solid #215a88'
}


const CustomNode = ({ nodeData }) => {

    return (
        <Fragment>
            {nodeData &&
                <Fragment>
                    <div className="nodeBox">
                        <div className={nodeData?.position_type == 2 ? 'fungsional' : 'position'}>{nodeData?.position_name}</div>
                        <div className="fullname">({nodeData?.position_grade} - {nodeData?.position_mapping_bkn_quota} - {nodeData?.count})</div>
                    </div>
                </Fragment>
            }
        </Fragment>
    )
}

CustomNode.propTypes = propTypes

export default CustomNode
